import EventsSection from "./EventsSection";

export default EventsSection;
